export default () => ({
    parent: pageId,
    loading: false,
    error: '',
    filters: {},

    form: {},

    filterInput: {
        ['@click']() {
            const input = this.$el;

            if(input.type === 'radio') {
                this.radioChecked(input);
            }

            this.submitFilter();
        }
    },

    radioChecked(input) {
        if (input.classList.contains('checked')) {
            input.classList.remove('checked');
            input.checked = false;
        }
        else {
            const inputs = document.querySelectorAll(`.filter__input[data-group="${input.dataset.group}"]`)

            for (const inputsItem of inputs) {
                if (inputsItem !== input) {
                    inputsItem.classList.remove('checked');
                    inputsItem.checked = false;
                }
            }

            input.classList.add('checked');
        }
    },

    button: {
        [':disabled']() {
            return this.loading;
        },

        ['x-show']() {
            return this.buttonShow
        },

        ['@click']() {
            if(! this.$el.disabled) {
                this.loadItems(false);
            }
        },
    },

    list: {
        [':class']() {
            return this.loading ? 'loading' : '';
        },
    },

    init() {
        this.page = 1;
        this.setFilterValuesFromUrl();
        this.getFilterValues();
        this.setButtonShow();
    },

    submitFilter() {
        this.page = 0;
        this.getFilterValues();
        this.setFilterHistory();
        this.loadItems();
    },

    setFilterValuesFromUrl() {
        const searchParams = new URLSearchParams(location.search);

        for (const [key, value] of searchParams) {
            if(key === 'search') {
                continue;
            }
            
            let values = value.split(',');

            for (const val of values) {
                let input = document.querySelector("#" + key + "-" + val);

                if (input !== null) {
                    input.checked = true;
                }
            }
        }
    },

    getFilterValues() {
        let filters = {};
        const form = document.querySelector('#filter-form');
        const formData = new FormData(form);

        for (const formItem of formData.entries()) {
            const itemKey = formItem[0];
            const itemValue = formItem[1];
            const newValue = [itemValue];

            let values = newValue;
            if (filters[itemKey] !== undefined) {
                values = filters[itemKey].concat(newValue);
            }

            filters[itemKey] = values;
        }

        let urlFull = new URL(location.href);
        let searchParam = urlFull.searchParams.get('search');
        if(searchParam) {
            filters['search'] = searchParam;
        }

        this.filters = filters;
    },

    setFilterHistory() {
        let href = location.href;
        let urlLocation = href.replace(location.search, '');
        let url = new URL(urlLocation);

        for (const key in this.filters) {
            url.searchParams.set(key, this.filters[key]);
        }

        window.history.pushState({}, '', url);
    },

    setButtonShow() {
        if (this.count == Object.keys(this.items).length) {
            this.buttonShow = false;
        }
        else {
            this.buttonShow = true;
        }
    },

    async loadItems(clear = true) {
        this.loading = true;
        this.page++;

        const url = new URL(location.origin + '/api/product');

        const params = {
            lang: lang,
            page: this.page,
            parent: this.parent,
        };
        const resultParams = Object.assign(params, this.filters);

        for (const key in resultParams) {
            url.searchParams.set(key, resultParams[key]);
        }

        let response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
                'X-csrf-token': _token
            },
        });

        let result = await response.json();

        if(clear) {
            this.items = result.items;
        }
        else {
            this.items = Object.assign(this.items, result.items);
        }

        this.error = result.error;
        this.loading = false;
        this.count = result.count;

        this.setButtonShow();
    }
})
